<div class="download-link-wrapper" [class.short]="isMultiple()">
  <app-download-link
    [fileData]="getFileData(fileIdsArray()?.[0]!)"
    [isMultiple]="isMultiple()"
    [style.width]="width"
    (onMultipleClick)="openFilesInfo($event)"
  ></app-download-link>
</div>

@if (isMultiple()) {
  <span class="count link-3" (click)="openFilesInfo($event)">...&nbsp;и&nbsp;еще&nbsp;{{fileIdsArray()?.length! - 1}}</span>
}
